// extracted by mini-css-extract-plugin
export default {"container":"privacypolicyscreen_container__VipZB"};